/**
 * Seleção do lote de transmissão: as notas marcadas ou todas as aguardando transmissão.
 * Espelha PrepararTransmissaoLoteNotaFiscalSaidaRequest (OrquestradorVendas).
 */
export class PrepararTransmissaoLoteNotaFiscalSaidaRequest {
  /** Notas selecionadas; vazio quando isTodasAguardandoTransmissao. */
  listaIdNFeSaida: number[] = [];
  /** Todas as notas da empresa aguardando transmissão (ignora listaIdNFeSaida). */
  isTodasAguardandoTransmissao = false;
  isIncluirRejeitadas = false;
}
